export default {
  LOAD_FILE: "root:LOAD_FILE",
  UPDATE_FILE: "root:UPDATE_FILE",
  LOAD_SAMPLE: "root:LOAD_SAMPLE",
  EXPORT_FILE_TSF: "root:EXPORT_FILE_TSF",
  EXPORT_FILE_CSV: "root:EXPORT_FILE_CSV",
  CONVERT_STANDARD: "root:CONVERT_STANDARD"
};
